export type DebitRejectionsTabsKeyValues = DEBIT_REJECTIONS_TABS_KEY_VALUES; 
export enum DEBIT_REJECTIONS_TABS_KEY_VALUES {
    POLICIES_WITH_OVERDUE_DEBT = '1',
    POLICIES_ALL = '2',
}
